import { get } from 'helpers/api';

export function buildNewDeal(path, listing) {
  return get(path, { params: { listingId: listing.id } });
}
